export default __webpack_public_path__ + "static/media/shipping.d585da70.png";